<div class="item-filter-container">

  <div class="filter-column">
    <div class="filter-field-control">
      <app-shared-custom-select
        (selectionChange)="onColumnChange($event)"
        [allowMultiple]="false"
        [allowEmptySelection]="false"
        [autoSubmitOnSelect]="true"
        [closeOnAutoSubmit]="true"
        [floatDropdown]="true"
        [placeholder]="'Select A Column'"
        [selected]="filter.column ? [filter.column] : []"
        [setOptions]="columnOptions"
        [showActionButtons]="false"
        [showChips]="false">
      </app-shared-custom-select>
    </div>
  </div>

  <div class="filter-type-column" [class.filter-type-column--disabled]="!filter.column">
    <div
      class="filter-type-control"
      [matTooltip]="'Select a column before choosing a filter type'"
      [matTooltipDisabled]="!!filter.column">
      <app-shared-custom-select
        (selectionChange)="onFilterTypeChange($event)"
        [allowMultiple]="false"
        [allowEmptySelection]="false"
        [autoSubmitOnSelect]="true"
        [closeOnAutoSubmit]="true"
        [floatDropdown]="true"
        [isDisabled]="!filter.column"
        [placeholder]="'Select type'"
        [selected]="filter.filterType ? [filter.filterType] : []"
        [setOptions]="filterTypeOptions"
        [showActionButtons]="false"
        [showChips]="false">
      </app-shared-custom-select>
    </div>
  </div>

  <div class="filter-value">
    @if (requiresFilterValueInput) {
      @if (getFilterTypeInputCount === 'single') {
        @if (filter.columnType !== 'boolean') {
          <input
            (blur)="onValueChange()"
            [(ngModel)]="filter.value"
            [disabled]="!filter.column || !filter.filterType"
            [type]="getFilterColumnType"
            class="filter-value-input"
            placeholder="Enter a Value"/>
        } @if (filter.columnType === 'boolean') {
          <input
            [(ngModel)]="filter.value"
            class="filter-value-checkbox"
            type="checkbox"/>
        }
      } @if (getFilterTypeInputCount === 'multiple' && filter.columnType !== 'boolean') {
        <div class="filter-value-range">
          <input
            (blur)="onRangeValueChange()"
            [(ngModel)]="rangeMin"
            [disabled]="!filter.column || !filter.filterType"
            [type]="getFilterColumnType"
            class="filter-value-input"
            placeholder="From"/>
          <span class="filter-value-range-separator" aria-hidden="true">–</span>
          <input
            (blur)="onRangeValueChange()"
            [(ngModel)]="rangeMax"
            [disabled]="!filter.column || !filter.filterType"
            [type]="getFilterColumnType"
            class="filter-value-input"
            placeholder="To"/>
        </div>
      }
    }
  </div>

  @if (allowRemove) {
    <app-shared-button (click)="onDeleteItemClick()" [fill]="false" [colour]="'clear'">
      <app-icon-delete-outline [tooltip]="'Delete Filter'"></app-icon-delete-outline>
    </app-shared-button>
  }

  @if (columnTypeLabel || showClientSideIsEmptyWarning) {
    <div class="filter-meta-row">
      <span class="filter-meta-label filter-meta-label--type">{{ columnTypeLabel }}</span>
      @if (showClientSideIsEmptyWarning) {
        <span class="filter-meta-label filter-meta-label--warning">{{ clientSideIsEmptySlowMessage }}</span>
      }
    </div>
  }

</div>
